<template>
  <div class="svv-search-list">
    <div class="ais-InstantSearch">
      <ais-instant-search
        :search-client="searchClient"
        :index-name="indexName"
        :routing="router"
        :search-function="searchFunction"
      >
        <ais-configure
          :filters="computeFilters"
          :aroundLatLngViaIP="isSortIp"
        />
        <div
          class="ssws-selected-filter"
          v-if="sections.includes('currentRefiments')"
        >
          <ais-current-refinements :transform-items="refactorRefinements">
            <!-- The slot is the same as in the main library, it just supports html in the label -->
            <template slot="refinement" slot-scope="{ refinement, refine }">
              <span
                role="option"
                tabindex="0"
                class="ais-CurrentRefinements-categoryLabel"
                :aria-label="stripAriaLabel(refinement.label)"
              >
                <q v-if="refinement.attribute === 'query'"
                  ><span>{{ refinement.label | strippedContent }}</span></q
                >
                <span v-else-if="refinement.label === 'true'">Ja</span>
                <span v-else-if="refinement.label === 'false'">Nej</span>
                <span v-else>{{ refinement.label | strippedContent }}</span>
              </span>
              <button
                role="button"
                tabindex="0"
                aria-label="tryck enter för att ta bort"
                class="ais-CurrentRefinements-delete"
                @click="refine(refinement)"
              >
                ✕
              </button>
            </template>
          </ais-current-refinements>
        </div>

        <div
          :class="[
            'search-panel-wrapper',
            {
              hideSearchPanel:
                sections.includes('hideRList') &&
                deviceType == 'mobile' &&
                showMap == false,
            },
          ]"
          v-if="sections.includes('filters')"
        >
          <div :class="activeTheme">
            <search-panel
              :filters="filters"
              :copy="copy"
              :selectedValuesList="selectedValuesList"
            ></search-panel>
          </div>
        </div>
        <div
          class="greymap-section"
          v-if="
            sections.includes('map') &&
            deviceType == 'mobile' &&
            showMap == false
          "
        >
          <button
            class="btn btn-primary"
            @click="
              showMap = true;
              showMapByBtn = true;
            "
          >
            {{ copy.showMap }}
          </button>
        </div>
        <div id="map" v-if="sections.includes('map')">
          <google-map
            v-if="showMap"
            :readMoreText="copy.itemsReadmoreText"
            :target="target"
            :markers="markers"
          />
        </div>
        <div
          :class="[
            'ssws-content-sec',
            { 'd-none': sections.includes('hideRList') },
          ]"
        >
          <div class="ssws_stats" aria-live="polite">
            <ais-stats>
              <h2 slot-scope="{ nbHits }">
                <span class="nb-hits-count">{{ nbHits }}</span>
                {{ copy.hitsTitle }}
              </h2>
            </ais-stats>
          </div>
        </div>
        <div
          :class="[
            'search-panel__results full-width',
            { 'd-none': sections.includes('hideRList') },
          ]"
        >
          <ais-infinite-hits :transform-items="transformItems">
            <template slot="item" slot-scope="{ item, index }">
              <component
                :is="getListComponent()"
                :index="index"
                :class="{ hidden: isHidden(index) }"
                :item="item"
                :copy="copy"
                :target="target"
              ></component>
            </template>

            <template
              slot="loadMore"
              v-if="copy.archive_pagination == 'pgination'"
            >
              <div class="addtional-css" :style="{ '--bkgImage': 'red' }"></div>
              <div class="nav-container" v-if="totalpages() > 1">
                <paginate
                  :page-count="totalpages()"
                  :page-range="3"
                  :margin-pages="1"
                  :click-handler="clickCallback"
                  :prev-text="'Föreg'"
                  :next-text="'Nästa'"
                  :container-class="getActiveTheme()"
                  :page-class="'page-item'"
                >
                </paginate>
              </div>
            </template>
            <template slot="loadMore" v-else>
              <div class="load-morebtn">
                <button
                  class="loadMore-sec"
                  :class="{
                    'cust-loadMore-btn--Disabled': pagination.isLastPage,
                  }"
                  v-if="totalpages() > 1"
                  @click="loadOnePage"
                >
                  {{ copy.loadMoreLabel }}
                </button>
              </div>
              <!-- <div class="pagination loadMore-sec" v-if="totalpages() > 1">
                  <span
                    class="cust-loadMore-btn"
                    :class="{
                      'cust-loadMore-btn--Disabled': pagination.isLastPage,
                    }"
                    @click="loadOnePage"
                  >
                    {{ copy.loadMoreLabel }}
                  </span>
                </div> -->
            </template>
          </ais-infinite-hits>
        </div>
      </ais-instant-search>
    </div>
  </div>
</template>
<script>
/* eslint-disable prettier/prettier, no-console */
//import Vue from 'vue';
import ListItem from './components/listItem';
import ListItemVardaga from './components/vardaga-website/listItem';
import ListItemAltiden from './components/altiden-website/listItem';
import ListItemStendi from './components/stendi-website/listItem';
import ListItemNytida from './components/nytida-website/listItem';
import GoogleMap from './components/map';
import SearchPanel from './components/searchPanel';
import router from './utility/router';
import localize from './utility/localize';
import 'instantsearch.css/themes/algolia-min.css';
import algoliasearch from 'algoliasearch';
import Paginate from 'vuejs-paginate';

import { createBrowserXhrRequester } from '@algolia/requester-browser-xhr';

/**
 * We need to replace client completely, old injection doesn't work anymore
 * Also need to update plugin, since settings section name is changed
 *
 * @returns {algoliasearch}
 */
const createSearchClient = () => {
    const localizedProxy = localize('svb_client_proxy');

    const clientProxy =
        typeof localizedProxy === 'string' && localizedProxy.length > 0
            ? localizedProxy
            : typeof window !== 'undefined' &&
                    window.algolia &&
                    typeof window.algolia.client_proxy === 'string'
              ? window.algolia.client_proxy
              : '';

    return algoliasearch(
        localize('svb_algolia_app') || '',
        localize('svb_algolia_api_key') || '',
        clientProxy
          ? {
              requester: {
                send(request) {
                  const requester = createBrowserXhrRequester();
                  const separator = clientProxy.includes('?') ? '&url=' : '?url=';

                  return requester.send({
                    ...request,
                    url: clientProxy + separator + request.url,
                  });
                },
              },
            }
          : undefined
    );
};

export default {
  components: {
    ListItem,
    ListItemVardaga,
    ListItemAltiden,
    ListItemStendi,
    ListItemNytida,
    SearchPanel,
    GoogleMap,
    Paginate,
  },
  data() {
    return {
      showMap: true,
      showMapByBtn: false,
      deviceType: 'desktop',
      router,
      items: [],
      searchClient: createSearchClient(),
      searchFunction(helper) {
        helper.search();
      },
      selectedValuesList: {},
      activeTheme: localize('svb_active_theme') || '',
      indexName: localize('svb_algolia_index') || '',
      target: localize('target') || 'self',
      filters: localize('filters') || [
        'search',
        'tjanst',
        'lan',
        'kommun',
        'malgrupp',
        'segment',
        'personkrets',
        'sswsDriftsform',
        'sswsIsNew',
        'lagrum',
        'diagnos',
      ],
      sections: localize('sections') || [
        'map',
        'filters',
        'currentRefiments',
        'hideRList',
      ],
      include: localize('include') || [],
      exclude: localize('exclude') || [],
      isSortIp: true,
      copy: {
        typeOfHome: localize('type_of_home') || 'Type of Home',
        chooseType: localize('choose_type') || 'Choose Type',
        region: localize('region') || 'Region',
        selectRegion: localize('select_region') || 'Select Region',
        municipality: localize('municipality') || 'Municipality',
        Kommune: localize('Kommune') || 'Kommune',
        selectMunicipality:
          localize('select_municipality') || 'Select Municipality',
        selectKommune: localize('selectKommune') || 'Vælg Kommune',
        searchTitle: localize('search_title') || 'Search',
        showMoreChoices:
          localize('show_more_choices') || 'Vis flere muligheder',
        targetGroup: localize('target_group') || 'Target Group',
        segmentTitle: localize('segment_title') || 'Segment',
        personalWithinLss:
          localize('personal_within_lss') || 'Personnel within LSS',
        operatingMode: localize('operating_mode') || 'Operating mode',
        lifestyle: localize('lifestyle') || 'Lifestyle',
        benefit: localize('benefit') || 'Benefit',
        offer: localize('tilbud') || 'Tilbud',
        select_offer: localize('vælg_tilbud') || 'Vælg tilbud',
        select_godkendtTil:
          localize('select_godkendtTil') || 'Vælg Godkendt Til',
        godkendtTil: localize('godkendtTil') || 'Godkendt Til',

        select_aldersgruppe:
          localize('select_aldersgruppe') || 'Vælg Aldersgruppe',
        aldersgruppe: localize('aldersgruppe') || 'Aldersgruppe',

        isNew: localize('is_new') || 'Is new',
        law: localize('law') || 'Law',
        diagnosTitle: localize('diagnos_title') || 'Diagnosis/specialties',
        showMap: localize('show_map') || 'Vis kort',
        applyChanges: localize('apply_changes') || 'Anvend valg',
        hitsTitle: localize('hits_title') || 'businesses were found',
        opensTitle: localize('opens_title') || 'Opens',
        ageRange: localize('age_range') || 'Age range',
        storageSpace: localize('storage_space') || 'Storage Space',
        numOfSeats: localize('num_of_seats') || 'Number of seats',
        numOfDepartments:
          localize('num_of_departments') || 'Number of departments',
        circleOfPersons: localize('circle_of_persons') || 'Circle of persons',
        itemsReadmoreText:
          localize('items_readmore_text') || 'See details/read more',
        operationalManager:
          localize('operational_manager') || 'Operations Manager',
        itemLeder: localize('Leder') || 'Leder',
        operationalManagerSkola:
          localize('operational_manager_skola') || 'Principal',
        telTitle: localize('tel_title') || 'Tel',
        mailTitle: localize('mail_title') || 'E-mail',
        visitingAddress: localize('visiting_address') || 'Visiting Address',
        visiting_Adresse: localize('visiting_Adresse') || 'Adresse',
        laes_mere: localize('laes_mere') || 'Læs mere',
        Paragraffer: localize('Paragraffer') || 'Paragraffer',
        Ledigplads: localize('Ledigplads') || 'Ledig plads',
        loadMoreLabel: localize('loadMoreLabel') || 'View more businesses',
        searchPlaceholder: localize('search_placeholder') || 'Sök...',
        archive_pagination:
          localize('archive_pagination').archive_pagination || 'load_more',
        noResults: localize('no_results') || 'No Results',
        selectedLabel: localize('selected_label') || 'Select',
      },
      pagination: {
        hitsPerPage: parseInt(localize('hitsPerPage')) || 20,
        currentPage: -1,
        totalItems: false,
        isLastPage: false,
      },
      colorFromScriptSetup: 'red',
    };
  },
  computed: {
    markers() {
      if (!this.items || !this.sections.includes('map')) {
        return [];
      }

      return this.computeMarkers(this.items);
    },
    computeFilters() {
      var filterString = '';
      if (this.include.length > 0) {
        filterString += '(';
        for (var i = 0; i < this.include.length; i++) {
          let single = this.include[i];
          filterString += 'metadata.ssws_verks-id:' + single.value;
          if (i < this.include.length - 1) {
            filterString += ' OR ';
          }
        }
        filterString += ')';
      }

      if (this.exclude.length > 0) {
        if (filterString !== '') {
          filterString += ' AND ';
        }
        filterString += '(';
        for (var x = 0; x < this.exclude.length; x++) {
          let single = this.exclude[x];
          filterString += 'NOT metadata.ssws_verks-id:' + single.value;
          if (x < this.exclude.length - 1) {
            filterString += ' AND ';
          }
        }
        filterString += ')';
      }
      return filterString;
    },
  },
  filters: {
    strippedContent: function (string) {
      return string.replace(/<\/?[^>]+>/gi, ' ');
    },
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    getListComponent() {
      var componentName = 'list-item';

      if (this.activeTheme === 'vardaga-website') {
        componentName = 'list-item-vardaga';
      } else if (this.activeTheme === 'altiden-website') {
        componentName = 'list-item-altiden';
      } else if (this.activeTheme === 'stendi-website') {
        componentName = 'list-item-stendi';
      } else if (this.activeTheme === 'nytida-website') {
        componentName = 'list-item-nytida';
      }
      return componentName;
    },
    themepagination() {
      let colorName;
      if (this.activeTheme === 'vardaga-website') {
        colorName = '#de3f2a';
      } else if (this.activeTheme === 'altiden-website') {
        colorName = '#de3f2a';
      } else {
        colorName = '#6ab651';
      }
      return colorName;
    },
    getActiveTheme() {
      let t1;
      if (this.activeTheme === 'vardaga-website') {
        t1 = 'vardaga_pagination';
      } else {
        t1 = 'pagination';
      }
      return t1;
    },
    clickCallback(pageNum) {
      this.pagination['currentPage'] = pageNum - 1;
      console.log('lp', pageNum);
    },
    totalpages() {
      return Math.ceil(
        this.pagination['totalItems'] / this.pagination['hitsPerPage']
      );
    },
    computeMarkers(items) {
      var markers = [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i];

        // Hide map marker for protected accommodation on Nytida
        if (
          this.activeTheme === 'nytida-website' &&
          item.taxonomies &&
          item.taxonomies['Tjänst'] &&
          item.taxonomies['Tjänst'].includes('Skyddat boende')
        ) {
          continue;
        }

        if (!item._geoloc) {
          continue;
        }

        var marker = {
          position: {
            lat: '',
            lng: '',
          },
          postTitle: '',
          image: '',
          tjanst: '',
          malgrupp: '',
          permalink: '',
          address: '',
        };

        marker.position = {
          lat: item._geoloc.lat,
          lng: item._geoloc.lng,
        };

        if (item.post_title) {
          marker.postTitle = item.post_title;
        }
        if (item.images && item.images.medium) {
          marker.image = item.images.medium.url;
        }
        if (item.taxonomies['Tjänst']) {
          marker.tjanst = item.taxonomies['Tjänst'].join(', ');
        }
        if (item.taxonomies['Målgrupp']) {
          marker.malgrupp =
            '<strong>' +
            this.copy.targetGroup +
            ': </strong>' +
            item.taxonomies['Målgrupp'].join(', ');
        }
        if (item.permalink) {
          marker.permalink = item.permalink;
        }

        if (
          this.activeTheme != 'altiden-website' &&
          this.activeTheme != 'stendi-website' &&
          item.metadata &&
          item.metadata.ssws_location &&
          item.metadata.ssws_location.address
        ) {
          marker.address = this.getAddressString(
            item.metadata.ssws_location.address
          );
        }

        markers.push(marker);
      }

      return markers;
    },
    getAddressString(addressObj) {
      var address = '';

      if (
        typeof addressObj.street !== 'undefined' &&
        addressObj.street !== ''
      ) {
        address += addressObj.street + ' ';
      }

      if (typeof addressObj.zip !== 'undefined' && addressObj.zip !== '') {
        address += addressObj.zip + ' ';
      }

      if (address !== '') {
        if (typeof addressObj.city !== 'undefined' && addressObj.city !== '') {
          address += addressObj.city + ' ';
        }
        return address.trim();
      }

      if (typeof addressObj.city !== 'undefined' && addressObj.city !== '') {
        return addressObj.city.trim();
      }

      if (
        typeof addressObj.municipality !== 'undefined' &&
        addressObj.municipality !== ''
      ) {
        return addressObj.municipality.trim();
      }

      if (
        typeof addressObj.region !== 'undefined' &&
        addressObj.region !== ''
      ) {
        return addressObj.region.trim();
      }

      return '';
    },
    stripAriaLabel(ariastring) {
      return ariastring.replace(/<\/?[^>]+>/gi, ' ');
    },
    checkDevice() {
      this.deviceType = window.innerWidth <= 768 ? 'mobile' : 'desktop';
      if (this.deviceType == 'desktop') {
        this.showMap = true;
      } else {
        if (this.showMapByBtn != true) {
          this.showMap = false;
        }
      }
    },
    refactorRefinements(items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        this.selectedValuesList[item.attribute] = item.refinements;
        if (item.attribute === 'metadata.ssws_is-new') {
          items[i].label = localize('is_new') || 'Is new';
          items[i].refinements[0].label = localize('is_new') || 'Is new';
        } else if (item.attribute === 'taxonomies.kommun') {
          let suffix = localize('municipality') || 'municipality';
          for (var x = 0; x < items[i].refinements.length; x++) {
            items[i].refinements[x].label =
              items[i].refinements[x].label + ' <span>(' + suffix + ')</span>';
          }
        }
      }
      return items;
    },
    checkIfLastPage() {
      let lastIndex = this.pagination['totalItems'] - 1;
      let from =
        this.pagination['currentPage'] * this.pagination['hitsPerPage'];
      let to = from + this.pagination['hitsPerPage'] - 1;

      if (lastIndex >= from && lastIndex <= to) {
        return true;
      }

      return false;
    },
    transformItems(items) {
      /*
      Better would be to check for different Objects, but pagination works well enough even when looking for different items.length.
      */
      if (items.length !== this.items.length) {
        this.pagination['currentPage'] = 0;
        this.pagination['totalItems'] = items.length;
        this.pagination['isLastPage'] = this.checkIfLastPage();

        this.items = JSON.parse(JSON.stringify(items));
      }

      return items;
    },
    isHidden(currentIndex) {
      if (this.copy.archive_pagination == 'pgination') {
        let from =
          this.pagination['currentPage'] * this.pagination['hitsPerPage'];
        let to = from + this.pagination['hitsPerPage'] - 1;
        if (currentIndex >= from && currentIndex <= to) {
          console.log(currentIndex);
          return false;
        } else {
          return true;
        }
      } else {
        let from =
          this.pagination['currentPage'] * this.pagination['hitsPerPage'];
        let to = from + this.pagination['hitsPerPage'] - 1;

        if (currentIndex <= to) {
          return false;
        }

        return true;
      }
    },
    loadOnePage() {
      if (this.pagination['isLastPage']) {
        return;
      }
      const sectionLoad = document.querySelectorAll('.ssws-item-section');
      this.pagination['currentPage']++;
      const calpage = this.pagination['currentPage'];
      const t = calpage * this.pagination['hitsPerPage'];
      const element = sectionLoad[t];

      console.log(
        'calpage',
        calpage,
        't',
        t,
        'element',
        element,
        "this.pagination['hitsPerPage']",
        this.pagination['hitsPerPage']
      );
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const anchorElement = element.querySelector('a'); // Finding the <a> element inside 'element'
        if (anchorElement) {
          setTimeout(() => {
            anchorElement.setAttribute('tabindex', '0'); // Making the <a> element focusable
            anchorElement.focus(); // Bringing focus to the <a> element
            anchorElement.classList.add('focused');
          }, 700);
        }
      }

      this.pagination['isLastPage'] = this.checkIfLastPage();
    },
  },
};
</script>
<style>
.ssws-content-sec h2 {
  color: #000 !important;
}
button.loadMore-sec.cust-loadMore-btn--Disabled {
  pointer-events: none;
  background: #ccc !important;
}
.svv-search-list .cust-loadMore-btn {
  cursor: pointer;
}
button.ais-InfiniteHits-loadMore.ais-InfiniteHits-loadMore--disabled {
  display: none;
}
.svv-search-list .cust-loadMore-btn.cust-loadMore-btn--Disabled {
  cursor: default;
  opacity: 0.5;
}
.svv-search-list .ais-InfiniteHits-item {
  margin-left: 0;
  padding: 0;
  border: 0;
  margin-top: 0;
  flex-basis: 100%;
  box-shadow: none;
}
.svv-search-list .ais-InfiniteHits-list {
  margin-left: 0;
  margin-top: 0;
}
.ais-CurrentRefinements .ais-CurrentRefinements-categoryLabel > span > span {
  font-size: 0.9rem;
}

.svv-search-list h3.item-title {
  margin: 0px !important;
}
.load-morebtn {
  width: 100%;
  text-align: center;
  margin-top: 25px;
}
.load-morebtn button.loadMore-sec {
  cursor: pointer;
  text-decoration: none;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  padding: 0.875rem 1.5rem;
  border-width: 2px;
  border-radius: 2rem;
  font-size: 1rem;
  color: #fff;
  background: #4a4a49;
  border: 0px;
  min-width: 200px;
  text-align: center;
}
.load-morebtn button.loadMore-sec:hover {
  background: #000;
}

.nav-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.nav-container ul {
  margin: 15px 0;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  border-radius: 3px;
  border: 1px solid #ccc;
}
.nav-container ul li {
  list-style: none;
  border-right: 1px solid #ccc;
  margin: 0;
  display: inline-block;
}
.nav-container ul li:last-child {
  border-right: none;
}

.nav-container ul li.disabled {
  display: none;
}
.nav-container ul li a {
  display: inline-block;
  text-decoration: none !important;
  border: none;
  font-weight: bold;
  color: #000 !important;
  padding: 6px 20px;
  font-size: 14px;
  letter-spacing: 0;
  min-width: 35px;
  text-align: center;
}
.nav-container ul li a:hover,
.nav-container ul li.active a {
  background: #de3f2a;
  color: #fff;
}
.nav-container ul.pagination li a:hover,
.nav-container ul.pagination li.active a {
  background: #6ab651;
  color: #fff;
}

.svv-search-form .multiselect__tag i:after {
  color: #fff;
  font-size: 100%;
}

.svv-search-form .multiselect__tag i {
  line-height: 1;
  font-size: 20px;
  font-weight: normal;
  top: -1px;
}
.svv-search-list .multiselect__input,
.svv-search-list .multiselect__single {
  font-size: 18px;
  margin: 0;
  padding: 0;
  top: 6px;
}
.search-panel .multiselect__option--selected.multiselect__option--highlight {
  background: #de3f2a !important;
  color: #fff !important;
}
.multiselect__option span.option_label {
  position: relative;
  z-index: 0;
}
.svv-search-list .multiselect__tags {
  padding: 7px 40px 0 8px;
  border-radius: 0;
  border: 1px solid #d2d2d1;
  font-size: 18px;
  min-height: 45px;
}
a.iteml-section {
  width: 100%;
  color: #000 !important;
}
.svv-search-list .multiselect__select:before {
  border-color: #212529 transparent transparent;
}
.svv-search-list .multiselect__input,
.svv-search-list .multiselect__single {
  font-size: 18px;
  margin: 0;
  padding: 0;
  top: 6px;
}
.svv-search-list .multiselect__placeholder {
  color: #212529;
  margin: 0 0 7px 0;
  white-space: nowrap !important;
}
.svv-search-list
  .ais-InstantSearch
  .ais-InfiniteHits
  .ais-InfiniteHits-list
  .ais-InfiniteHits-item
  .ssws-item-section
  h3.item-title {
  color: #000 !important;
}
.svv-search-list
  .ais-InstantSearch
  .ais-InfiniteHits
  .ais-InfiniteHits-list
  .ais-InfiniteHits-item
  .ssws-item-section
  .e-post
  a {
  overflow-wrap: break-word;
}
.search-panel .down-arrow {
  display: inline-grid;
  align-items: center;
}
.h3style {
  margin: 0px !important;
  color: #000 !important;
  padding-bottom: 10px;
}
.h3style span {
  font-size: 1.5rem !important;
  font-family: BrownLLWeb-Bold;
}
p.plaster,
p.group,
p.person-kit {
  font-size: 1rem;
}
p.content {
  margin-top: 10px;
}

.hideSearchPanel {
  display: none;
}

.ssws_search_panel-tab-button.more-btn:focus,
.ssws_search_panel-tab-button.more-btn:focus-visible,
.ssws_search_panel-tab-button.more-btn:focus-within,
.search-panel__filters.more-filters:focus,
.search-panel__filters.more-filters:focus-visible,
.search-panel__filters.more-filters:focus-within {
  outline: 3px solid #177ffb;
  border-radius: 3px;
}

.svv-search-list .ais-InstantSearch .loadMore-sec:focus-visible {
  outline: 3px solid #a800c3 !important;
}

.greymap-section {
  width: 100%;
  height: 100px;
  background-image: url('demomapbg_gray.jpg');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}

.greymap-section button {
  padding: 0.5rem 0.7rem;
  margin-right: 10px;
  margin-left: 0;
  margin-bottom: 0.4rem;
  background-color: #921e14;
  font-size: 1rem;
  border: none !important;
  border-radius: 5px;
  color: #fff;
}

.morechoice-section-btn,
.morechoice-section {
  display: none;
}

@media (min-width: 991px) {
  .ssws-item-section {
    justify-content: space-between;
  }
  .ssws-item-section .right-sec {
    min-width: 315px !important;
    width: auto !important;
    max-width: 315px !important;
  }
}
@media (max-width: 767px) {
  .svv-search-list
    .ais-InstantSearch
    .ais-InfiniteHits
    .ais-InfiniteHits-list
    .ais-InfiniteHits-item
    .ssws-item-section
    a.iteml-section {
    flex-direction: column;
  }
  .svv-search-list
    .ais-InstantSearch
    .search-panel
    .ssws_search_panel-tab-button.more-btn {
    justify-content: flex-end;
  }
  .ais-InstantSearch
    .ais-CurrentRefinements
    .ais-CurrentRefinements-item
    .ais-CurrentRefinements-category
    button.ais-CurrentRefinements-delete {
    position: initial !important;
    margin-left: 10px !important;
  }

  .multiselect__select:before {
    top: 23px !important;
    border-color: #212529 transparent transparent !important;
    color: #212529 !important;
  }

  .ssws_search_panel_dropdown {
    position: fixed !important;
    bottom: 0 !important;
    top: auto !important;
  }
  .search-panel .search-more-item-wrap {
    display: block !important;
  }
  .search-panel .search-more-item-wrap .search-panel__filters {
    width: 100% !important;
  }
  .search-panel
    .search-panel__filters.more-filters
    .ssws_search_panel_dropdown {
    max-height: 50vh !important;
    overflow: hidden !important;
  }
  .svv-search-list
    .ais-InstantSearch
    .search-panel
    .more-filters
    .ssws_search_panel_dropdown {
    margin-top: 0px !important;
    border: none !important;
    border-radius: 10px 0px !important;
    padding: 0px !important;
    overflow-x: hidden !important;
  }
  .search-more-item-wrap {
    padding: 1rem 1rem 1rem 1rem !important;
    max-height: 100%;
    height: calc(50vh - 129px);
    overflow-y: scroll;
  }
  .search-panel__filters h3 {
    font-size: 1em !important;
  }
  .ais-RefinementList-list .ais-RefinementList-item {
    font-size: 1rem !important;
  }
  .svv-search-list
    .ais-InstantSearch
    .search-panel
    .ssws_search_panel_dropdown
    .ais-RefinementList-item
    a {
    padding: 0.35rem 0 0.35rem 5px !important;
  }
  .morechoice-section {
    display: flex;
    justify-content: space-between;
    background: #921e14;
    color: #fff !important;
    padding: 0.5rem 1rem !important;
    width: 100%;
    border-radius: 10px 10px 0 0;
  }
  .altiden-website .morechoice-section {
    background: #b8460f;
  }
  .svv-search-list
    .ais-InstantSearch
    .search-panel
    .ssws_search_panel_dropdown
    .ais-RefinementList-item
    .ais-RefinementList-count {
    padding: 4px 8px 3px 5px !important;
    border-radius: 5px !important;
    margin-left: 10px !important;
  }
  .search-panel .search-more-item-wrap .search-panel__filters {
    padding: 0 !important;
  }
  .search-panel .search-more-item-wrap .search-panel__filters h3 {
    padding-left: 5px !important;
  }
  .ssws_search_panel_inner_sec {
    display: flex;
    flex-direction: column;
  }
  .morechoice-section-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 25px;
  }
  .morechoice-section-btn span {
    background: #921e14;
    width: 240px;
    height: 44px;
    border-radius: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .altiden-website .morechoice-section-btn span {
    background: #b8460f;
  }
}
</style>
